export default __webpack_public_path__ + "4d6f202d1d1912a6d4fef2392ed318a2.png";